import TCMap from './component/map.vue';
var CoreMapPlugin = /** @class */ (function () {
    function CoreMapPlugin() {
    }
    CoreMapPlugin.install = function (Vue, options) {
        Vue.component('tc-map', TCMap);
        console.log('installing core map');
    };
    return CoreMapPlugin;
}());
export default CoreMapPlugin;
